import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Slide,
} from "@mui/material";
import "./DeleteModal.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DeleteModal = ({ open, onClose, onConfirm, secondaryText = null }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      keepMounted
      className="delete-modal"
    >
      <DialogTitle className="delete-title">Потврда за бришење</DialogTitle>
      <DialogContent className="delete-content">
        <Typography>
          Дали сте сигурни дека сакате да го избришете ова?
        </Typography>
        {secondaryText ?? <Typography>{secondaryText}</Typography>}
      </DialogContent>
      <DialogActions className="delete-actions">
        <Button onClick={onClose} variant="outlined" className="delete-cancel">
          Откажи
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          className="delete-confirm"
        >
          Избриши
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteModal;
